<script>
  import Video from "./Video.svelte";
  import { navigate } from "svelte-routing";
  import Navbar from "./Navbar.svelte";
  import metacombined from "./metacombined.json";
  import BigNumber from 'bignumber.js';
  import {COLLECTION_ID} from './constants';

  const boys = Object.keys(metacombined).map((boy) => ({
    ...metacombined[boy],
    id: boy,
  }));

  function viewBoy(id) {
    setTimeout(() => {
      window.scrollTo(0,0);
      navigate(`/boy/${id}`);
    }, 100);
  }

  // type OrderItem = {
  //   take: {
  //     assetType: {
  //       assetClass: string,
  //     },
  //     value: string,
  //   },
  //   make: {
  //     assetType: {
  //       assetClass: string,
  //       contract: string,
  //       tokenId: string,
  //     },
  //     value: string,
  //   },
  //   cancelled: false,
  //   fill: string,
  // }

  let ordersMap = {};
  fetch(
    "https://api.rarible.com/protocol/v0.1/ethereum/order/orders/sell/byCollection?collection="+COLLECTION_ID
  )
    .then((r) => {
      return r.json();
    })
    .then(({ orders }) => {
      console.log(orders);
      orders.forEach((order) => {
        ordersMap[order.make.assetType.tokenId] = order;
      });
    });

  function formatOrder(order) {
    try {
      return new BigNumber(order.take.value)
        .div("1000000000000000000")
        .toNumber();
    } catch(e) {
      console.error(e)
      return "err";
    }
  }
</script>

<div class="bg-blackSplash text-white min-h-full">
  <Navbar dark={true} />
  <div class="md:p-20 p-10 text-center">
    <h2 class="font-pixel mb-10 text-center text-6xl">THE GENESIS BOYS</h2>
    <p class="font-pixel mb-10 text-center text-3xl">
      The genesis boys were all hand-drawn by the founder of the xx based off her own and her friends stories.
    </p>
    <p class="font-pixel mb-10 text-center text-3xl">
      Each has their own unique story and style.
    </p>
    <p class="font-pixel mb-10 text-center text-3xl">
      Half are up for public sale to kick-off the launch.
    </p>
    <div class="grid md:grid-cols-3 2xl:grid-cols-5 justify-center">
      {#each boys as boy}
        <div
          on:click={(evt) => {
            evt.preventDefault();
            viewBoy(boy.id)
          }}
          class="m-2 cursor-pointer opacity-90 transition duration-300 hover:scale-110 hover:opacity-100 text-center bg-gray-800 p-2 rounded-lg"
        >
          <Video
            poster={`/boys/render_frame1/${
              boy.animation_url.match(/([^/]+)\.mp4$/)[1]
            }_1.png`}
            size=""
            src={boy.animation_url}
          />
          <h5 class="font-pixel 2xl:text-3xl md:text-xl mt-2">{boy.name}</h5>
          {#if ordersMap[boy.id] && ordersMap[boy.id].fill === "0" && ordersMap[boy.id].cancelled === false}
            <div class="font-pixel 2xl:text-3xl md:text-xl mt-1">
              Price: {formatOrder(ordersMap[boy.id])} eth
            </div>
          {/if}
        </div>
      {/each}
    </div>
    <div style="background-image:url(/boys/generative-montage.png); background-position: -100px top; position: absolute; margin-top:50px; left: -200px; right: 0; height: 400px; background-repeat: repeat-y" />
    <div style="height: 500px; position: relative;"></div>
    <h2 class="font-pixel mb-10 text-center text-6xl">THE GENERATIVE BOYS</h2>
    <h5 class="font-pixel mb-10 text-center text-3xl">
      Coming soon ~</h5>
      <p class="font-pixel mb-10 text-center text-2xl" >The XX and owners of the genesis fboys will guide the future release of the generative boys.</p>
  </div>
</div>
